"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhaseName = exports.InteractionName = void 0;
var InteractionName;
(function (InteractionName) {
    InteractionName["FMP"] = "first-meaningful-paint";
    InteractionName["LoadExperiments"] = "load-experiments";
    InteractionName["LoadWidgetSettings"] = "load-widget-settings";
    InteractionName["LoadPaymentMethods"] = "load-payment-methods";
    InteractionName["PayPalLoadScript"] = "paypal-load-script";
    InteractionName["PayPalCreateOrder"] = "paypal-create-order";
    InteractionName["PayPalOnPaymentAuthorizedFetchData"] = "paypal-on-payment-authorized-fetch-data";
    InteractionName["PayPalUpdateOrder"] = "paypal-update-order";
    InteractionName["ApplePayValidateMerchant"] = "apple-pay-validate-merchant";
})(InteractionName = exports.InteractionName || (exports.InteractionName = {}));
var PhaseName;
(function (PhaseName) {
    PhaseName["LoadMainBundle"] = "load-main-bundle";
    PhaseName["LoadSettings"] = "load-preload-data";
})(PhaseName = exports.PhaseName || (exports.PhaseName = {}));
//# sourceMappingURL=InteractionName.js.map